import { Button } from '~/shadcn/ui/button/button'
import { Spinner } from '~/shadcn/ui/spinner'
import { HeadingTwo } from '~/@mid_ui/typography/HeadingTwo'
import { Text } from '~/@mid_ui/typography/Text'
import {
  TwoFaVerifyForm,
  type TwoFaVerifyFormState,
} from '~/@mid_2fa/twofa-verify-form/TwoFaVerifyForm'
import { useTwoFaCodeExpirationCountdown } from '~/@mid_2fa/twofa/useTwoFaCodeExpirationCountdown'
import { CodeExpirationCountdown } from '~/@mid_2fa/twofa/CodeExpirationCountdown'

type Props = {
  twoFaCodeExpiresAt: Date | null
  isRequesting: boolean
  error: string | null
  handleSubmitForm: (props: TwoFaVerifyFormState) => void
  handleResendLoginTwoFaCode: () => void
  handleGoBack: () => void
}

function LoginFormTwoFa({
  twoFaCodeExpiresAt,
  isRequesting,
  error,
  handleSubmitForm,
  handleResendLoginTwoFaCode,
  handleGoBack,
}: Props) {
  const { countdown, hasCodeExpired } =
    useTwoFaCodeExpirationCountdown(twoFaCodeExpiresAt)
  return (
    <div className="p-4">
      {hasCodeExpired && (
        <div className="flex flex-col items-center gap-4 text-center">
          <HeadingTwo className="text-2xl max-w-md mb-2">
            Dvojfaktorová autentifikácia
          </HeadingTwo>
          <Text>SMS kód vypršal.</Text>
          <Button variant="outline" onClick={handleResendLoginTwoFaCode}>
            Znova odoslať SMS kód{` `}
            {isRequesting && <Spinner className="size-4" />}
          </Button>
        </div>
      )}
      {!hasCodeExpired && (
        <TwoFaVerifyForm
          isRequesting={isRequesting}
          formContent={
            <div className="flex flex-col items-center text-center">
              <HeadingTwo className="text-2xl max-w-md mb-2">
                Dvojfaktorová autentifikácia
              </HeadingTwo>
              Pre prihlásenie prosím zadajte SMS kód,
              <br />
              ktorý vám bol zaslaný na vaše telefónne číslo.
              <br />
              <CodeExpirationCountdown countdown={countdown} />
            </div>
          }
          FooterComponent={(props) => (
            <div
              className="flex flex-col items-center justify-center mt-8 gap-2 w-full"
              {...props}
            />
          )}
          handleSubmitForm={handleSubmitForm}
          handleGoBack={handleGoBack}
          error={error}
        />
      )}
    </div>
  )
}

export { LoginFormTwoFa }
